// extracted by mini-css-extract-plugin
module.exports = {"root":"banner-icon-close_root__y3ISU","levelapp":"banner-icon-close_levelapp__E94h5"};